// vim: set ts=2 sw=2 et tw=72 ft=javascript:
/**
 * Copyright (C) 2015 Minted Inc.
 *
 * All Rights Reserved
 *
 * CTAG:COMMUNITY:ACTIVITY_FEED
 */

var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/moment.min.js': 'moment',
  'minted:vendor/underscore-1.8.2.min': '_'
})(this, function (m_module, Backbone, $, moment, _) {

  "use strict";

  var M = m_module.M;
  M.Community = M.Community || {};
  M.Community.View = M.Community.View || {};
  M.Community.View.Util = M.Community.View.Util || {};

  M.Community.View.Util.ActivityFeedPanel = Backbone.View.extend({
    numObjectsToShow: 3,

    initialize: function() {
      M.required(this.options.activityList);
      M.required(this.options.$parentContainerEl);

      if (this.options.activityList.length < 4) {
        // if less than 4 activities, then don't show activity feed
        return;
      }

      this.numObjectsToShow =
        this.options.numObjectsToShow || this.numObjectsToShow;

      // We only want to show full rows of three activity tiles
      // Trim the list of activities received, if needed
      this.activityList = this._trimActivityList();

      this.$parentContainerEl = this.options.$parentContainerEl;

      this._createListPanel();
    },

    render: function() {
      return this;
    },

    _createActivityTileViews: function() {
      var that = this;
      this.activityTileViews = [];

      _.each(this.activityList, function(activity) {
        var activityFeedTileModel = new M.Community.Model.ActivityFeedTile({
          activityType: activity['activityType'],
          userAvatarUrl: activity['userAvatarUrl'],
          userProfileUrl: activity['userProfileUrl'],
          userName: activity['userName'],
          timingStr: activity['timingStr'],
          activityThumbnailUrl: activity['activityThumbnailUrl'],
          messagePreview: activity['messagePreview'],
          calloutUrl: activity['calloutUrl'],
          activityLinkUrl: activity['activityLinkUrl']
        });

        var activityFeedTileView = new M.Community.View.Util.ActivityFeedTile({
          model: activityFeedTileModel
        });

        that.activityTileViews.push(activityFeedTileView);
      });
    },

    _createListPanel: function() {
      var that = this;
      // create all the activity tile views
      this._createActivityTileViews();

      new M.Community.View.Util.ListPanel ({
        title: 'recent activity',
        list: this.activityTileViews,
        listItemClass: 'activityFeedTile',
        numObjectsToShow: that.numObjectsToShow,
        parentContainer: this.$parentContainerEl,
        emptyPanelText: 'We\'re having trouble loading this. Please try again later.',
        // show the panel header upon expansion using the showHide panel
        shouldToggleHeader: true
      });
    },

    _trimActivityList: function() {
      // Assure that activity feed tiles are rendered in multiples
      // of three.
      var activityList = this.options.activityList;
      var activityCount = activityList.length;
      var remainderCount = activityCount % this.numObjectsToShow;

      // disregard the remaining tiles
      if ( remainderCount != 0 ) {
        var numRows = Math.floor(activityCount / this.numObjectsToShow);
        // only show up to the cuttOffIndex-th tile
        var cutOffIndex = (numRows * this.numObjectsToShow);
        activityList = activityList.slice(0, cutOffIndex);
      }
      return activityList;
    }

  });

  return {
  };

});